import React, { useState } from "react";
import {
  SectionContainer,
  SectionTitleBody,
  SectionTitleHeading,
  SectionTitle,
  BackgroundColor,
  Price
} from "@silversea-ssc/ui-components-react";
import {
  CruiseSectionShipFragment,
  CruiseSectionShipVersionFragment
} from "types/graphql-types";
import { isNullOrUndefined } from "src/utils/checks";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { ActivePromoForCruise } from "src/utils/promos";
import MosaicSuites from "./MosaicSuites";
import { CruisePriceAndOffersV2Response } from "src/ssc-api/prices/useCruisePrice";

const ShipSuiteModal = React.lazy(
  () => import("components/ShipFacilityModal/ShipSuiteModal")
);

export type CruiseSectionSuitesProps = {
  cruiseCode: string;
  cruisePrice?: CruisePriceAndOffersV2Response;
  ecommerceStatus: ECommerceStatus;
  activePromos: ActivePromoForCruise[];
  backgroundColor: BackgroundColor;
  ship: CruiseSectionShipFragment;
  shipVersion: CruiseSectionShipVersionFragment;
  title: string | undefined;
  raqPagePath: string | undefined;
};

export type CruiseSuiteOpenModalArgs = {
  type: string;
  suiteCode: string;
  prices: Price[];
  raqCTAUrl: string | undefined;
  ecommerceStatus: ECommerceStatus | undefined;
};

const CruiseSectionSuites: React.FC<
  React.PropsWithChildren<CruiseSectionSuitesProps>
> = ({
  cruiseCode,
  cruisePrice,
  ecommerceStatus,
  activePromos,
  backgroundColor,
  children,
  ship,
  shipVersion,
  title,
  raqPagePath
}) => {
  const [openedModal, setOpenModal] =
    useState<CruiseSuiteOpenModalArgs | null>();

  if (isNullOrUndefined(ship) || isNullOrUndefined(shipVersion)) return null;

  return (
    <React.Fragment>
      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor={backgroundColor}
        dataContentName="section_suites"
      >
        <SectionTitle variant="wide">
          <SectionTitleHeading>{title}</SectionTitleHeading>
          <SectionTitleBody>{children}</SectionTitleBody>
        </SectionTitle>

        <MosaicSuites
          cruisePrice={cruisePrice}
          cruiseCode={cruiseCode}
          shipId={ship._id!}
          ecommerceStatus={ecommerceStatus}
          setOpenModal={setOpenModal}
          activePromos={activePromos}
          shipVersion={shipVersion}
          raqPagePath={raqPagePath}
        />
      </SectionContainer>

      {ship?.fullPath && openedModal && shipVersion && shipVersion._key && (
        <React.Suspense>
          <ShipSuiteModal
            modal={{
              isOpen: !!openedModal,
              onRequestClose: () => setOpenModal(null)
            }}
            shipPath={ship.fullPath}
            {...openedModal}
            shipVersionKey={shipVersion._key}
          />
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

export default CruiseSectionSuites;
